// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__DHF-v","question":"Question_question__318hg","description":"Question_description__ubbeH"};